// react
import { ReactNode, useContext } from 'react';

// types
import { Contract } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// router
import { Link as RouterLink } from 'react-router-dom';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// mui
import { Link, LinkProps, Typography } from '@mui/material';

// props
export interface LinkContractProps extends LinkProps {
	children?: ReactNode;
	contract: Contract;
	[x: string]: unknown;
}

export const LinkContract = ({ children, contract, ...props }: LinkContractProps) => {
	// hooks
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// vars
	let link = <Typography>{t('na')}</Typography>;

	if (children || contract) {
		// vars
		const content = children || contract.num;

		link = (
			<Link
				component={RouterLink}
				fontWeight={600}
				sx={{ wordBreak: 'break-word' }}
				to={`/project/${project?.idWbg}/contracts`}
				underline="hover"
				{...props}>
				{content}
			</Link>
		);
	}

	return link;
};
